export default __webpack_public_path__ + "static/media/7.87469b88.png";